import { render, staticRenderFns } from "./QCReportPage.vue?vue&type=template&id=ab4897c4&scoped=true&"
import script from "./QCReportPage.vue?vue&type=script&lang=js&"
export * from "./QCReportPage.vue?vue&type=script&lang=js&"
import style0 from "./QCReportPage.vue?vue&type=style&index=0&id=ab4897c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4897c4",
  null
  
)

export default component.exports